import React from 'react';
import { Link } from 'school-space-client/components';

const PaymentFailed = () => {
    return (
        <div className="row">
            <div className="col-md-12 mx-auto mt-5">
                <div className="payment">
                    <div className="content">
                        <h1>Payment failed !</h1>
                        <p />
                        <Link url="/">Go to Home</Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PaymentFailed;
